import React from "react";
import Login from '../Login';
import AboutUs from '../../Pages/AboutUs';
import Support from '../../Pages/Support';
import JwtComponent from "../JwtComponent";
import ConfirmEmail from "../ConfirmEmail";
import ResetPassword from '../ResetPassword';
import ForgotPassword from '../ForgotPassword';
import NotFound from "../../Pages/NotFound/NotFound";
import { Route } from "react-router-dom";
import { EndPoints } from "../../../utils/apiEndpoints";

const {
    LOGIN, FORGOTPASSWORD, RESETPASSWORD, ABOUTUS, SUPPORT, JWTAPI, CONFIRMEMAIL,
} = EndPoints;

export const NotAuthenticatedRoutes = () => {
    const routes = [
        { path: "/", element: <Login /> },
        { path: LOGIN, element: <Login /> },
        { path: FORGOTPASSWORD, element: <ForgotPassword /> },
        { path: RESETPASSWORD, element: <ResetPassword /> },
        { path: ABOUTUS, element: <AboutUs /> },
        { path: SUPPORT, element: <Support /> },
        { path: JWTAPI, element: <JwtComponent /> },
        { path: CONFIRMEMAIL, element: <ConfirmEmail /> },
        { path: "*", element: <NotFound /> },
    ];

    return <>
        {
            routes.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
            ))
        }
    </>;
};
